import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const FILE_FORMAT_FAMILYRULE_EDITOR_CLASS_NAME =
	'FileFormatFamilyRuleEditor';
export const FILE_FORMAT_FAMILYRULE_EDITOR_CLASS_SLOTS = ['root'] as const;

export type FileFormatFamilyRuleEditorClassSlot =
	(typeof FILE_FORMAT_FAMILYRULE_EDITOR_CLASS_SLOTS)[number];

export interface FileFormatFamilyRuleEditorClasses {
	root: string;
}

export type FileFormatFamilyRuleEditorClassKey =
	keyof FileFormatFamilyRuleEditorClasses;

export const getFileFormatFamilyRuleEditorUtilityClass = (slot: string) =>
	generateUtilityClass(FILE_FORMAT_FAMILYRULE_EDITOR_CLASS_NAME, slot);

export const fileFormatFamilyRuleEditorClasses: FileFormatFamilyRuleEditorClasses =
	generateUtilityClasses(FILE_FORMAT_FAMILYRULE_EDITOR_CLASS_NAME, ['root']);

export default fileFormatFamilyRuleEditorClasses;
